module.exports = __webpack_public_path__ + "static/media/vehicle-pin-dark.8ddda53c.svg";